angular.module('leanlaw').controller('CodesBillablesCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', "exportJson", "singleRequest", "objectNumberManipulator", "messageBus", function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, exportJson, singleRequest, objectNumberManipulator, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = 'mattertag.label';
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      accum.push({
        "Activity": c.code.label,
        "Billable hours": $filter("hoursDecimal")(c.data.hours.billable),
        "Non-billable hours": $filter("hoursDecimal")(c.data.hours.nonBillable),
        "Total hours": $filter("hoursDecimal")(c.data.hours.total),
        "Fixed fees": $filter("amount")(c.data.amounts.charges),
        "Expenses": $filter("amount")(c.data.amounts.expenses),
        "Total amount": $filter("amount")(c.data.amounts.total)
      });
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  userService.me().then(me => {
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      $scope.filter = Object.assign($scope.filter, payload);
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;
      filterClientEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  });
  function filterClientEntries() {
    console.log($scope.filter);
    $scope.loading = true;
    var query = reportsService.queryFromFilter($scope.filter);
    query.data = "services,expenses,charges,hours";
    query.primary = 'codes';
    singleRequest.serviceCall("clientEntries", reportsService.getReport)(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("clientEntries");
    deactivate();
  });
  $scope.goToSummary = function (code) {
    $state.go("reports.codes-billables-detail", {
      code: code.id,
      return: "reports.codes-billables",
      report: `Billable by Activity`
    });
  };
  $scope.$watch("search", () => {
    if (!$scope.data || !$scope.data.filteredClients) return; // Not loaded yet

    // Wait for DOM update because filteredClients is updated there
    $timeout(() => {
      // Reset total
      objectNumberManipulator.resetValues($scope.data.data);
      // Update sums
      $scope.data.filteredClients.forEach(fc => {
        objectNumberManipulator.sumValues($scope.data.data, fc.data);
      });
    });
  });
}]);